<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  //接口地址url的统一管理
  import URL from '@/api/im/url'
  import { localRead } from '@/utils/tools'
  import Qs from 'qs'

  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    created() {
      for (const i in this.businessGroupData) {
        let code = this.businessGroupData[i].code
        let name = this.businessGroupData[i].name
        this.bizCodeObj[code] = name
        this.bizCodes.push(code)
      }
      for (const i in this.langList) {
        let code = this.langList[i].id
        let name = this.langList[i].name
        this.localeObj[code] = name
        this.locales.push(code)
      }
      for (const i in this.enableType) {
        let code = this.enableType[i].value
        let name = this.enableType[i].title
        this.enableObj[code] = name
      }
      this.updateData = {
        cols: [
          { title: 'id', field: 'id', hidden: true },
          {
            title: window.$t('im.common.bizCode'),
            field: 'bizCode',
            type: 2,
            required: true,
            optionList: this.bizCodeObj
          },
          {
            title: window.$t('im.common.locale'),
            field: 'locale',
            type: 2,
            required: true,
            optionList: this.localeObj
          },
          { title: window.$t('im.privateWelcome.message'), field: 'message', type: 6, required: true }
        ]
      },
        this.formData.cols = [
          { title: window.$t('im.common.bizCode'), field: 'bizCode', type: 2, optionList: this.bizCodeObj },
          { title: window.$t('im.common.locale'), field: 'locale', type: 2, optionList: this.localeObj },
          { click: window.$t('im.bt.search') },
          { click: window.$t('im.bt.reset') },
          { click: window.$t('im.bt.add') }
        ]
    },
    methods: {
      /*表格按钮点击事件*/
      bthClick(clickName, row) {
        if (clickName == 'update') {
          this.$refs.childUpdate.open(row)
        } else if (clickName == 'delete') {
          this.dataDelete(URL.privateWelcome.privateWelcomeDelete, { id: row.id }, res => {
            if (res.code == 0) {
              this.$message.success('suc')
            } else {
              this.$message.error(res.message)
            }
          })
        } else if (clickName == 'enableOrNot') {
          row['enable'] = row['enable'] == 0 ? 1 : 0
          this.dataChanage(URL.privateWelcome.privateWelcomeUpdate, row, res => {
            if (res.code == 0) {
              this.$refs.childUpdate.close()
              this.$message.success('suc')
            } else {
              this.$message.error(res.message)
            }
          })
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data) {
        if ('查询' == clickName || window.$t('im.bt.search') == clickName) {
          data['bizCodes'] = this.bizCodes
          data['locales'] = this.locales
          data['serviceToken'] = this.userInfo.userToken
          this.queryData = data
          this.$refs.childTable.defaultGetData(data)
        } else if ('新增' == clickName || window.$t('im.bt.add') == clickName) {
          this.$refs.childUpdate.open()
        } else if ('重置' == clickName || window.$t('im.bt.reset') == clickName) {
          this.formData.cols = [
            { title: window.$t('im.common.bizCode'), field: 'bizCode', type: 2, optionList: this.bizCodeObj },
            { title: window.$t('im.common.locale'), field: 'locale', type: 2, optionList: this.localeObj },
            { click: window.$t('im.bt.search') },
            { click: window.$t('im.bt.reset') },
            { click: window.$t('im.bt.add') }
          ]
          this.$refs.childForm.queryListData()
        } else if ('列表显示隐藏' == clickName || window.$t('im.bt.hideOrNo') == clickName) {
          this.pageData.isShow = !this.pageData.isShow
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model) {
        //根据是否包含id更新还是添加
        if (!!model.id) {
          this.dataChanage(URL.privateWelcome.privateWelcomeUpdate, model, res => {
            if (res.code == 0) {
              this.$refs.childUpdate.close()
              this.$message.success('suc')
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          this.dataChanage(URL.privateWelcome.privateWelcomeAdd, model, res => {
            if (res.code == 0) {
              this.$refs.childUpdate.close()
              this.$message.success('suc')
            } else {
              this.$message.error(res.message)
            }
          })
        }
      },
      dataChanage(url, option, suc, fail) {
        option['operatorName'] = this.userInfo.displayName
        option['operator'] = this.userInfo.id
        option['serviceToken'] = this.userInfo.userToken
        option['companyId'] = this.userInfo.companyId
        this.$axios.post(url, option, {
          headers: {
            'isAjax': 'true',
            'Content-Type': 'application/json'
          }
        }).then(res => {
          this.$refs.childTable.defaultGetData(this.queryData)
          if (suc && (typeof suc == 'function')) suc(res)
        }).catch(res => {
          if (fail && (typeof fail == 'function')) fail(res)
        })
      },
      dataDelete(url, option, suc, fail) {
        this.$axios.post(url, Qs.stringify(option || {})).then(res => {
          this.$refs.childTable.defaultGetData(this.queryData)
          if (suc && (typeof suc == 'function')) suc(res)
        }).catch(res => {
          if (fail && (typeof fail == 'function')) fail(res)
        })
      },
      getDesc(array, value) {
        let res = ''
        array.forEach(item => {
          if (item.value === value) {
            res = item.title
            return res
          }
        })
        return res
      },
      brushBusinessGroup(data) {
        for (const i in this.businessGroupData) {
          if (this.businessGroupData[i].code == data) {
            return this.businessGroupData[i].name
          }
        }
        return ''
      },
      brushLocale(data) {
        for (const i in this.langList) {
          if (this.langList[i].id == data) {
            return this.langList[i].name
          }
        }
        return ''
      }
    },
    data() {
      return {
        userInfo: JSON.parse(localRead('sys_userInfo_IM')),  //用户信息
        langList: JSON.parse(localRead('locale_IM')),  //语言列表
        businessGroupData: JSON.parse(localRead('sys_userInfo_IM')).businessIdUser,  //业务编码列表
        enableType: [
          { value: 0, title: window.$t('im.common.enableNo') },
          { value: 1, title: window.$t('im.common.enableYes') }
        ],
        bizCodeObj: {},
        localeObj: {},
        enableObj: {},
        deleteIds: '',
        queryData: {},
        bizCodes: [],
        locales: [],
        /*新增或更新*/
        updateData: {},
        /*from查询表单*/
        formData: {
          hasLable: true,
          cols: []
        },
        /*table生成*/
        pageData: {
          isShow: false,
          queryUrl: URL.privateWelcome.privateWelcomeList, //请求路径和参数
          selection: false,
          sequence: false,
          method: 'post-json',
          cols: [
            {
              title: window.$t('im.common.bizCode'), field: 'bizCode', render: (data) => {
                return this.brushBusinessGroup(data)
              }
            },
            {
              title: window.$t('im.common.locale'), field: 'locale', render: (data) => {
                return this.brushLocale(data)
              }
            },
            { title: window.$t('im.privateWelcome.message'), field: 'message' },
            { title: window.$t('im.common.createDate'), field: 'createDate' },
            { title: window.$t('im.common.updateDate'), field: 'updateDate' },
            {
              title: window.$t('im.bt.operator'), btnClick: [
                { name: window.$t('im.bt.update'), size: 'mini', click: 'update', type: 'primary' },
                { name: window.$t('im.bt.delete'), size: 'mini', click: 'delete', type: 'primary' }]
            }
          ]
        }
      }
    }
  }
</script>
